import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

import { zodResolver } from '@hookform/resolvers/zod';

import { z } from 'zod';

import { convertPaymentRegisterValue, convertPaymentValue } from '@/utils/convertValue';

import * as S from './style';
import Field from '../../Field/Field';

interface PaymentModalProps {
	closeModal: (bool: boolean) => void;
	onComplete: (data: { presentation: string; section: string }) => void;
}

interface RegisterField {
	presentation: string;
	section: string;
}

const PaymentModal = ({ closeModal, onComplete }: PaymentModalProps) => {
	const userRegisterSchema = z.object({
		presentation: z.string(),
		section: z.string(),
	});
	const { register, handleSubmit, watch, setValue } = useForm<RegisterField>({
		resolver: zodResolver(userRegisterSchema),
		mode: 'onChange',
		defaultValues: {
			presentation: '구두 발표',
			section: '소재 분과',
		},
	});

	const handlePresentation = (presentation: string) => {
		setValue('presentation', presentation);
	};
	const onSubmit = async (data: RegisterField) => {
		onComplete(data);
		closeModal(false);
	};
	return (
		<S.PaymentContainer onSubmit={handleSubmit(onSubmit)}>
			<S.Title>등록 옵션</S.Title>

			<Field title="발표별" gap="0.8rem">
				<S.PaymentContentBox>
					<S.PaymentContent className={watch('presentation') === '구두 발표' ? 'active' : ''} onClick={() => handlePresentation('구두 발표')}>
						구두 발표
					</S.PaymentContent>
					<S.PaymentContent className={watch('presentation') === '포스터 발표' ? 'active' : ''} onClick={() => handlePresentation('포스터 발표')}>
						포스터 발표
					</S.PaymentContent>
				</S.PaymentContentBox>
			</Field>

			<Field title="분과별" gap="0.8rem">
				<S.GenderBox>
					<S.GenderRadio>
						<input type="radio" value="소재 분과" {...register('section')} />
						소재 분과
					</S.GenderRadio>
					<S.GenderRadio>
						<input type="radio" value="제형 분과" {...register('section')} />
						제형 분과
					</S.GenderRadio>
					<S.GenderRadio>
						<input type="radio" value="평가 및 임상 분과" {...register('section')} />
						평가 및 임상 분과
					</S.GenderRadio>
					<S.GenderRadio>
						<input type="radio" value="피부 & 천연물효능 기전 분과" {...register('section')} />
						피부 & 천연물효능 기전 분과
					</S.GenderRadio>
					<S.GenderRadio>
						<input type="radio" value="대체법 분과" {...register('section')} />
						대체법 분과
					</S.GenderRadio>
					<S.GenderRadio>
						<input type="radio" value="안전성 분과" {...register('section')} />
						안전성 분과
					</S.GenderRadio>
					<S.GenderRadio>
						<input type="radio" value="AI 분과" {...register('section')} />
						AI 분과
					</S.GenderRadio>
					<S.GenderRadio>
						<input type="radio" value="기타 분과" {...register('section')} />
						기타 분과
					</S.GenderRadio>
				</S.GenderBox>
			</Field>

			<S.PaymentButtonBox>
				<S.CancelButton type="button" onClick={() => closeModal(false)}>
					취소
				</S.CancelButton>
				<S.PaymentConfirmButton type="submit">등록</S.PaymentConfirmButton>
			</S.PaymentButtonBox>
		</S.PaymentContainer>
	);
};

export default PaymentModal;
